import { useCallback, useMemo, useState } from 'react';
import useSearchParamsConfig from './useSearchParamsConfig';

export default function useAllocationFilters(defaultSearchParams) {
  const filters = useMemo(
    () => ({
      allocationBookingTypeId: null,
      allocationBillableTypes: [],
    }),
    [],
  );

  const [defaultParams] = useState(defaultSearchParams);

  const searchParamsConfig = useSearchParamsConfig();

  const allocationSearchParamsConfig = useMemo(
    () => ({
      allocationBookingTypeId: searchParamsConfig.allocationBookingTypeId,
      allocationBillableTypes: searchParamsConfig.allocationBillableTypes,
      ...defaultParams,
    }),
    [searchParamsConfig, defaultParams],
  );

  const mapUrlSearchParams = useCallback(
    (filters) => ({
      allocationBookingTypeId: filters.allocationBookingTypeId ?? undefined,
      allocationBillableTypeId: filters.allocationBillableTypes?.map((v) => v.id),
    }),
    [],
  );

  return useMemo(
    () => ({ filters, searchParamsConfig: allocationSearchParamsConfig, mapUrlSearchParams }),
    [filters, allocationSearchParamsConfig, mapUrlSearchParams],
  );
}
